import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LocalStorage } from "@/types/enums";
import { State } from "../state";
import { AuthPayload } from "@/app/graphql/codegen";

// WICHTIG: Die Reducer sollten nicht außerhalb der useAuthActions Hook verwendet werden.
// Die useAuthActions Hook synchronisiert den Redux Store mit dem localStorage
export const authSlice = createSlice({
    name: "auth",
    initialState: {
        token: localStorage.getItem(LocalStorage.AUTH_TOKEN) ?? "",
        user: {
            id: localStorage.getItem(LocalStorage.USER_ID) ?? "",
            email: localStorage.getItem(LocalStorage.USER_EMAIL) ?? "",
        },
    } as State.Auth,
    reducers: {
        /**
         * WICHTIG: Nicht außerhalb der useAuthActions Hook verwenden!
         */
        setAuth: (state, action: PayloadAction<AuthPayload>) => {
            // Pure update of auth state, local storage side effects handled in useAuthActions
            const { email, id, authToken } = action.payload;

            state.user.email = email;
            state.user.id = id;
            state.token = authToken;
        },
        /**
         * WICHTIG: Nicht außerhalb der useAuthActions Hook verwenden!
         */
        clearAuth: (state) => {
            state.token = "";
            state.user.email = "";
            state.user.id = "";
        },
    },
});

export const { setAuth, clearAuth } = authSlice.actions;

// export const useAuthSlice = () => useSelector((state: RootState) => state.auth);

export default authSlice.reducer;
